<template>
    <modal
        id="terminate-payment-subscription-modal"
        :centered="true"
        :close="modal.close"
        :closeable="modal.closable"
        :show="modal.show"
        :title="$t('order.terminateSubscriptionTitle')"
        size="modal-lg"
        @modal-close="
            modal.show = false;
            modal.close = false;
        "
    >
        <form
            :action="terminateSubscriptionUrl"
            enctype="multipart/form-data"
            method="post"
            @submit.prevent="onTerminatePaymentSubscriptionSubmit"
        >
            <div class="modal-body pt-0">
                <div class="row">
                    <div
                        v-if="
                            response.show &&
                            typeof response.message === 'string' &&
                            response.message.length > 0
                        "
                        class="col-12"
                    >
                        <div
                            :class="{
                                'alert-success': response.success,
                                'alert-danger': !response.success,
                            }"
                            class="alert"
                        >
                            <p class="mb-0">{{ response.message }}</p>
                        </div>
                    </div>

                    <div v-if="modal.showForm" class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <p v-html="$t('order.terminateSubscriptionText')"></p>
                            </div>

                            <div class="col-12">
                                <div
                                    class="d-flex align-items-center justify-content-start h-checkbox"
                                >
                                    <div>
                                        <input
                                            id="payment_subscription"
                                            v-model="form.confirmation"
                                            class="checkbox"
                                            name="confirmation"
                                            required
                                            type="checkbox"
                                        />
                                    </div>
                                    <label
                                        class="ml-3"
                                        for="payment_subscription"
                                        v-html="$t('order.terminateSubscriptionConfirmCheckbox')"
                                    ></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-end bg-light">
                <button
                    v-if="modal.showForm"
                    :disabled="ongoing"
                    class="btn btn-secondary"
                    type="button"
                    v-html="$t('generic.cancel')"
                    @click.prevent="onAbortTerminatePaymentSubscription"
                ></button>
                <button
                    :disabled="ongoing"
                    class="btn btn-primary"
                    type="submit"
                >
                    <i
                        v-if="ongoing"
                        class="mdi mdi-loading mdi-spin"
                    ></i>
                    <span
                        v-else-if="!modal.showForm"
                        v-html="$t('frontend.close')"
                    ></span>
                    <span v-else v-html="$t('order.terminateSubscriptionConfirm')"></span>
                </button>
            </div>
        </form>

        <loading-animation
            :always-show="false"
            :loading-text="$t('order.terminationOngoing')"
            :visible="ongoing"
            preloader-container-id=""
            status-container-id=""
        ></loading-animation>
    </modal>
</template>

<script>
export default {
    name: 'TerminateSubscriptionModal',
    props: {
        terminateSubscriptionUrl: {
            type: String,
            required: false,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            form: {
                confirmation: false,
            },
            modal: {
                show: false,
                close: false,
                closable: true,
                showForm: true,
            },
            response: {
                show: false,
                success: false,
                message: null,
            },
            ongoing: false,
        };
    },
    methods: {
        /**
         * Trigger the visibility of the terminate payment subscription modal.
         *
         * @returns {void}
         */
        onTerminatePaymentSubscription() {
            this.modal.show = true;
            this.modal.close = false;
            this.modal.closable = true;
            this.modal.showForm = true;
        },

        /**
         * Handle the abort callback of the payment subscription termination modal.
         *
         * @returns {void}
         */
        onAbortTerminatePaymentSubscription() {
            this.modal.closable = !this.ongoing;
            this.modal.show = false;
            this.modal.close = true;
            this.modal.showForm = true;
        },

        /**
         * Send the request to cancel the order subscription.
         *
         * @returns {void}
         */
        onTerminatePaymentSubscriptionSubmit() {
            // A request is already ongoing, then restrict the access to the submit until the previous
            // request was completed.
            if (this.ongoing) {
                return;
            }

            // If the form isn't visible reload the page, on confirmation.
            if (!this.modal.showForm) {
                window.location.reload();

                return;
            }

            // Reset the error message of the form.
            this.response.show = false;
            this.response.message = null;
            this.response.success = false;
            this.modal.closable = true;

            // In the case the checkbox wasn't checked, then cancel the submit of the form.
            if (!this.form.confirmation) {
                this.response.message = this.$t('order.pleaseConfirmSubscriptionTerminate');
                this.response.success = false;
                this.response.show = true;

                return;
            }

            this.ongoing = true;
            this.modal.closable = false;

            axios
                .post(this.terminateSubscriptionUrl, this.form)
                .then((response) => {
                    this.response.message = response.data.message;
                    this.response.success = response.data.success;
                    this.response.show = true;
                    this.modal.showForm = !this.response.success;
                    this.modal.closable = true;
                    this.ongoing = false;

                    setTimeout(function () {
                        this.$emit('done');
                    }, 15);
                })
                .catch(() => {
                    this.response.message = this.$t('order.subscriptionTerminateFailed');
                    this.response.show = true;
                    this.response.success = false;
                    this.ongoing = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
